<template>
    <el-container style="height: 100%">
        <el-header style="height: 50px">
            <van-nav-bar title="员工绩效" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main style="padding: 0px;height: 100%">
            <el-form :inline="true" :model="param">
                <el-form-item label="月份">
                    <el-date-picker v-model="param.month" type="month" size="mini" placeholder="选择月" value-format="yyyy-MM" @change="getInteboStaffFine"></el-date-picker>
                </el-form-item>
                <el-form-item label="员工">
                    <el-select v-model="param.staffid"  popper-class="myselect" @change="getInteboStaffFine" clearable
                               default-first-option style="width: 100%" filterable size="mini">
                        <el-option v-for="val of staffInfos" :key="val.staffid"  :value="val.staffid" :label="val.staffname"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="openAdd" size="mini">新增</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getStaffFineByParamExcel" size="mini">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table class="date-table" :data="staffFineData" size="mini" :border=true stripe height="calc(100% - 4rem)">
                <el-table-column  prop="accountdate" label="日期">
                    <template slot-scope="scope">
                        {{$moment(scope.row.accountdate).format('YYYY-MM-DD')}}
                    </template>
                </el-table-column>
                <el-table-column  prop="staffname" label="核算对象"></el-table-column>
                <el-table-column  prop="amount" label="绩效核减"></el-table-column>
                <el-table-column  prop="reason" label="核减原因"></el-table-column>
                <el-table-column  label="操作">
                    <template slot-scope="scope">
                        <el-button @click="updateStaffFineState(scope)" type="text" :loading="queryLoadBtton" size="small" style="color: red">作废</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-dialog title="新增员工处罚" :visible.sync="dialogVisible" width="100%" top="0px">
            <el-form ref="form" :model="addStaffFine" label-width="140px" size="mini" :rules="rules">
                <el-form-item label="单据编号" prop="sysbillid">
                    {{addStaffFine.sysbillid}}
                </el-form-item>
                <el-form-item label="单据日期" prop="accountdate">
                    <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100%"
                                    v-model="addStaffFine.accountdate"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="核算对象" prop="staffid">
                    <el-select v-model="addStaffFine.staffid"  popper-class="myselect" default-first-option style="width: 100%" filterable size="mini">
                        <el-option v-for="val of staffInfos" :key="val.staffid"  :value="val.staffid" :label="val.staffname"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="绩效核减" prop="amount">
                    <el-input type="input" v-model.trim="addStaffFine.amount" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="核减原因" prop="reason">
                    <el-input type="textarea" autosize placeholder="请输入内容" v-model="addStaffFine.reason">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="saveStaffFine()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            rules:{
                accountdate: [
                    {required: true, message: "请选择日期", trigger: 'blur'},
                ],
                staffid: [
                    {required: true, message: "请选择核算对象", trigger: 'blur'},
                ],
                amount:[
                    {required: true, message: "请输入绩效核减", trigger: 'blur'},
                ],
                reason:[
                    {required: true, message: "请输入核减原因", trigger: 'blur'},
                ]
            },
            staffInfos:[],
            queryLoadBtton:false,
            dialogVisible:false,
            staffFineData:[],
            param:{
                month:this.$moment().startOf('month').format('YYYY-MM'),
                staffid:"",
            },
            stafffine:{
                storeid:localStorage.getItem("storeid"),
                sysbillid:"",
                staffid:"",
                finetype:"95233823b84b47e2b378e2f9c87031ec",
                finetypename:"制度处罚",
                accountdate:this.$moment().format('YYYY-MM-DD'),
                amount:0,
                reason:"",
                punish:"",
                state:1,
                createdate:"",
                createtor:localStorage.getItem("staffid"),
                createname:localStorage.getItem("staffname"),
                gsstoreid:localStorage.getItem("storeid"),
            },
            addStaffFine:{},
        }
    },
    created() {
        this.getInteboStaffByParam();
        this.getInteboStaffFine();
    },
    methods:{
        getStaffFineByParamExcel(){
            let fromdate=this.param.month+"-01";
            let todate=this.$moment(fromdate).endOf('month').format('YYYY-MM-DD');
            let token=localStorage.getItem("token");
            window.open(process.env.API_ROOT+"stafffine/getStaffFineByParamExcel?storeid="+this.stafffine.storeid+"&fromdate="+fromdate+"&todate="+todate+"&token="+token+"&finetype=95233823b84b47e2b378e2f9c87031ec" +
                "&strings=&punishs=");
        },
        updateStaffFineState(scope){
            this.$dialog.confirm({
                title: '删除',
                message: "您确定要作废该绩效信息吗",
            }).then(() => {
                this.queryLoadBtton=true;
                scope.row.state=2;
                this.$postw("stafffine/updateStaffFineState",scope.row).then(res=>{
                    this.queryLoadBtton=false;
                    if(res.sucess){
                        this.$message({message: '作废成功', type: 'success'});
                        this.getInteboStaffFine();
                    }
                });
            });
        },
        getInteboStaffFine(){
            let storeid=localStorage.getItem("storeid");
            let fromdate=this.param.month+"-01";
            let todate=this.$moment(fromdate).endOf('month').format('YYYY-MM-DD');
            this.$post("inteboStaff/getInteboStaffFine",{storeid:storeid,fromdate:fromdate,todate:todate,staffid:this.param.staffid}).then(res=>{
                if(res.sucess){
                    this.staffFineData=res.object;
                }
            });
        },
        saveStaffFine(){
            this.queryLoadBtton=true;
            this.$postw("inteboStaff/saveStaffFine",this.addStaffFine).then(res=>{
                this.queryLoadBtton=false;
                if(res.sucess){
                    this.getInteboStaffFine();
                    this.dialogVisible=false;
                    this.$message({message: '保存成功', type: 'success'});
                }
            });
        },
        openAdd(){
            this.addStaffFine=this.$copy(this.stafffine);
            this.dialogVisible=true;
            this.getSysBillId();
        },
        getSysBillId(){
            this.$post("product/getSysBillId").then(res=>{
                if(res.sucess){
                    this.addStaffFine.sysbillid=res.object;
                }
            });
        },
        getInteboStaffByParam() {
            this.$post("inteboStaff/getInteboStaffByParam", {posid:'', status: 1}).then(res => {
                if (res.sucess) {
                    this.staffInfos = res.object;
                }
            });
        },
        historyBack(){
            this.$router.push({path:'/intebotab'});
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebostaff/intebostafffine.vue